'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { PricingCard } from '@spikemark/ui/components/design-system/pricing-card';
import { DialogContent } from '@spikemark/ui/components/ui/dialog';
import { useUserContext } from '@/providers/user-context-provider';
import { cn } from '@spikemark/ui/utils/cn';
export const UpgradeDialogContent: FC<{
  hasStandardAccess?: boolean;
  contentOnly?: boolean;
}> = ({
  hasStandardAccess,
  contentOnly
}) => {
  const router = useRouter();
  const handleProClick = async () => {
    router.push('/checkout/packages?selection=pro');
  };
  const handleStandardClick = async () => {
    router.push('/checkout/packages?selection=standard');
  };
  const {
    tierData
  } = useUserContext();
  const {
    standardPackage,
    proPackage
  } = tierData;
  const showStandardPlan = !hasStandardAccess;
  const Wrapper = contentOnly ? 'div' : DialogContent;
  return <Wrapper className="lg:max-w-5xl lg:max-h-9/10" data-sentry-element="Wrapper" data-sentry-component="UpgradeDialogContent" data-sentry-source-file="upgrade-dialog-content.tsx">
      <div>
        <h1 className="text-2xl font-semibold pb-3">Upgrade your Coach Portal account</h1>
        <p className="font-medium text-pl-gray-600">
          Take your Coach Portal to the next level by unlocking additional tools and functionality
          to better support your team.
        </p>
      </div>

      <div className="overflow-auto">
        <div className="flex flex-row flex-wrap md:flex-nowrap justify-center gap-8 pt-7 pb-4">
          {showStandardPlan && <div className="flex flex-1 max-w-[430px]">
              <PricingCard title="Standard" description="For teams who want live scoring for practice and qualifying" price={standardPackage?.price ?? undefined} features={standardPackage?.features} hasButton={true} handleClick={handleStandardClick} />
            </div>}
          <div className={cn('flex flex-1', showStandardPlan ? 'max-w-[430px]' : 'w-full')}>
            <PricingCard title="Pro" description="For teams that want to level up through detailed team, player and tournament analytics" price={proPackage?.price ?? undefined} information="Redesigned and enhanced analytics that highlight the stats that really matter" highlight={true} features={proPackage?.features} hasButton={true} handleClick={handleProClick} containerClassName={showStandardPlan ? '' : 'flex-1'} data-sentry-element="PricingCard" data-sentry-source-file="upgrade-dialog-content.tsx" />
          </div>
        </div>
      </div>
    </Wrapper>;
};